import { render, staticRenderFns } from "./PlayerVideo.vue?vue&type=template&id=5578ae9a&scoped=true&"
import script from "./PlayerVideo.vue?vue&type=script&lang=js&"
export * from "./PlayerVideo.vue?vue&type=script&lang=js&"
import style0 from "./PlayerVideo.vue?vue&type=style&index=0&id=5578ae9a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5578ae9a",
  null
  
)

export default component.exports